export default "__VITE_ASSET__48a13f4d__"